<script>
  import { format } from 'svelte-i18n';

  import { Icon } from '@client/components/icon';

  export let recipient = null;

  const onRemove = () => {
    recipient = null;
  };
</script>

{#if recipient}
  <span class="filter">
    <Icon name="filter" />
    <span class="content">
      <slot>{$format('label.DATA_RECIPIENT_FILTERING', { values: { recipient } })}</slot>
    </span>
    <Icon name="x" on:click={onRemove} role="button" tabindex="0" />
  </span>
{/if}

<style lang="scss" src="./recipient-filtering.scss"></style>
